import React from 'react'
import { Redirect, useLocation } from 'react-router-dom'
import { useUser } from '@paintscout/ui'

interface TrialExpiredGuardProps {
  children: React.ReactNode
}

/**
 * Guard component that redirects trial-expired users to the appropriate dashboard
 * Only allows access to billing/settings routes when trial is expired
 */
export default function TrialExpiredGuard({ children }: TrialExpiredGuardProps) {
  const { isTrial, trialExpired, isSuperadmin, isSupport } = useUser()
  const location = useLocation()

  // Allow access to settings/billing routes even when trial is expired
  const isBillingRoute = location.pathname.startsWith('/settings')

  // If trial is expired and user is on a trial, redirect to dashboard (which will show the appropriate trial over dashboard)
  // Superadmin and support bypass this block as they are internal staff
  if (isTrial && trialExpired && !isBillingRoute && location.pathname !== '/dashboard' && !isSuperadmin && !isSupport) {
    return <Redirect to="/dashboard" />
  }

  return <>{children}</>
}
